"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { usePathname } from "next/navigation";
import { getOrganizationMembershipsAction } from "@/app/_actions/organizations";
import { ContextSwitcher } from "@/components/blocks/ContextSwitcher";
import { SidebarNavSection } from "@/components/blocks/SidebarNavSection";
import { SidebarUserMenu } from "@/components/blocks/SidebarUserMenu";
import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader, SidebarSeparator } from "@/components/ui/sidebar";
import { extractDistrictSlug, FOOTER_NAV_ITEMS, getOrgNavItems, PLAYER_NAV_ITEMS } from "@/config/sidebar-navigation";
export function AppSidebar() {
  const $ = _c(15);
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname) {
    t0 = extractDistrictSlug(pathname);
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const districtSlug = t0;
  const isDistrictWorkspaceIndex = pathname === "/dashboard/d";
  const isOrgContext = !!districtSlug || isDistrictWorkspaceIndex;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      queryKey: ["organization-memberships"],
      queryFn: _temp,
      staleTime: 300000
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: memberships
  } = useQuery(t1);
  let t2;
  if ($[3] !== districtSlug || $[4] !== isDistrictWorkspaceIndex || $[5] !== isOrgContext || $[6] !== memberships) {
    const activeMembership = isOrgContext ? memberships?.find(m => m.districtSlug === districtSlug || m.organizationSlug === districtSlug) ?? (isDistrictWorkspaceIndex ? memberships?.find(_temp2) : null) : null;
    const resolvedDistrictSlug = districtSlug ?? activeMembership?.districtSlug ?? activeMembership?.organizationSlug ?? null;
    t2 = isOrgContext && activeMembership && resolvedDistrictSlug ? getOrgNavItems(resolvedDistrictSlug, activeMembership.role) : [];
    $[3] = districtSlug;
    $[4] = isDistrictWorkspaceIndex;
    $[5] = isOrgContext;
    $[6] = memberships;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const orgNavItems = t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SidebarHeader className="pt-4 pb-3"><ContextSwitcher /></SidebarHeader>;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== isOrgContext || $[10] !== orgNavItems) {
    t4 = <SidebarContent>{isOrgContext ? <SidebarNavSection items={orgNavItems} /> : <SidebarNavSection items={PLAYER_NAV_ITEMS} />}</SidebarContent>;
    $[9] = isOrgContext;
    $[10] = orgNavItems;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SidebarFooter><SidebarNavSection items={FOOTER_NAV_ITEMS} className="p-0" /><SidebarSeparator className="mx-0 mb-1" /><SidebarUserMenu /></SidebarFooter>;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4) {
    t6 = <Sidebar collapsible="icon">{t3}{t4}{t5}</Sidebar>;
    $[13] = t4;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
function _temp2(membership) {
  return membership.isActive;
}
function _temp() {
  return getOrganizationMembershipsAction();
}